
import React from "react";
import { Form } from "react-final-form";
// import { useAuthProvider, useRedirect } from "react-admin";
import AppBar from "../../../Components/header/index";
import MentorProfile from "../../../Screens/MentorProfile/Components/mentorProfile"
import ScheduleAppointmentForm4 from "../../../Screens/ScheduleAppointment/Components/scheduleAppointment4"
import AppProvider from "../../../Components/bootstrap"
// import { useRouteState } from "../../../Utils/hooks"
// import { Parse } from "../../../Utils/parseDataProvider";
import { useAuthenticated } from "react-admin";
import {useAppointment} from "../hooks"
const ScheduleAppointment4 = props => {
  // const redirect = useRedirect();
  const {addRequestMessage} = useAppointment()
  useAuthenticated()
  return (
    <div style={{zoom:"88%"}}>
    <AppProvider>
        <AppBar />
        <MentorProfile typography="Home / Mentor Profile / Schedule Appointment"/>
        <div >
          <Form
            initialValues={{
              // isMentor
            }}
            onSubmit={async response => {
              addRequestMessage(response.message)
            }}
            
            keepDirtyOnReinitialize
            render={ScheduleAppointmentForm4}
          />
        </div>
    </AppProvider>
  </div>
  );
};
export default ScheduleAppointment4;
